module.exports = __webpack_public_path__ + "assets/img/warrior-name-c29b2f8d.png";